import React, { useCallback, useState } from 'react';
import ContainedImage from '../../ContainedImage';
import { useSafeImageSrc } from '../../SafeImage';
import ModalUserAvatar from './ModalUserAvatar';
import styles from './UserAvatar.module.scss';

export const FALLBACK_USER_AVATAR_IMAGE = 'img/no_avatar.png';

const UserAvatar = (props) => {
    const { className = '', user, showStatus, round = true, onClick, size, altSrc = FALLBACK_USER_AVATAR_IMAGE } = props,
        src = user.image_url ?? user.photo_url,
        [showModal, setShowModal] = useState(false),
        hasAvatar = useSafeImageSrc(src, altSrc) !== altSrc; // it's not pretty having this when already using ContainedImage but safeSrc is memoized

    const handleOpenModal = useCallback(() => setShowModal(true), []),
        handleCloseModal = useCallback(() => setShowModal(false), []);

    const handleClick = useCallback(
        (e) => {
            if (onClick) onClick(e);
            else if (hasAvatar) {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModal();
            }
        },
        [onClick, hasAvatar, handleOpenModal]
    );

    let favoriteIcon, statusIcon;
    if (showStatus) {
        if (user.is_favorite) {
            favoriteIcon = <div className="favorite" />;
        }
        if (user.status == 'online') {
            statusIcon = <div className="status online"></div>;
        } else if (user.status == 'offline') {
            statusIcon = <div className="status offline"></div>;
        } else {
            statusIcon = <div className="status inactive"></div>;
        }
    }

    return (
        <>
            <ContainedImage src={src} altSrc={altSrc} size={size} onClick={handleClick} className={[className, 'avatar', round ? 'round' : '', styles.UserAvatar].join(' ')}>
                {favoriteIcon}
                {statusIcon}
            </ContainedImage>
            {showModal ? <ModalUserAvatar user={user} onClose={handleCloseModal} /> : null}
        </>
    );
};

export default UserAvatar;
